import React, { useState, useContext, useEffect, useRef, useCallback, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  checkPermission
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { UserContext } from "../../../../../contexts/User";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { FoodContext } from "../../../../../contexts/Food";
import WastageReport from "./WastageReport";
import KdsModal from "../../kitchen/KdsModal";
import DataTable from "../../../../common/DataTable";


const WastageFood = () => {
  const { t } = useTranslation();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  const { foodForPOS, propertyItemList } = useContext(FoodContext);

  let {
    branchForSearch,
  } = useContext(RestaurantContext);

  let {
    authUserInfo,
    //wastage      
    wastageItemList,
    setWastageItemList,
    setPaginatedWastageLists,
    wastageItemListForSearch,
    setWastageItemListForSearch,

    //pagination
    dataPaginating,
  } = useContext(UserContext);

  let common_toast = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  }

  //search result
  let [searchedWastage, setSearchedWastage] = useState({
    list: null,
    searched: false,
  });
  const [itemData, setItemData] = useState({
    modal: false,
    url: "",
    name: "",
    token: ""
  });
  const searchRef = useRef(null);

  useEffect(() => {
    setPaginatedWastageLists(1);
  }, []);

  // image pop up
  const handleOpenPopup = (item) => {
    setItemData({
      modal: true,
      url: BASE_URL + item?.sw_document,
      token: `PI Document: ${item.document_identity}`,
    })
  };

  const handleClosePopup = () => {
    setItemData({
      modal: false,
      url: "",
      name: "",
      token: "",
    })
  };

  //search purchase here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedWastage({ ...searchedWastage, searched: false });
    } else {
      let searchedList = wastageItemListForSearch.filter((item) => {
        //name
        let lowerCaseDocNo = item.document_identity?.toLowerCase();

        //email
        let lowerCaseItemRemarks = item.remarks?.toLowerCase();
        let lowerCaseBranch = item.branch_name?.toLowerCase();
        return (
          (lowerCaseItemRemarks && lowerCaseItemRemarks.includes(searchInput)) ||
          (lowerCaseDocNo && lowerCaseDocNo.includes(searchInput)) ||
          (lowerCaseBranch && lowerCaseBranch.includes(searchInput))
        );
      });
      setSearchedWastage({
        ...searchedWastage,
        list: searchedList,
        searched: true,
      });
    }
  };

  // print bills states and function
  const [newRow, setNewRow] = useState([]);
  const [documentDate, setDocumentDate] = useState(new Date());
  let [newWastage, setNewWastage] = useState("");
  const componentRef = useRef();
  const handleOnlyPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleGetPrintData = async (id) => {
    const url = BASE_URL + "/settings/signal-stock-wastage/" + parseInt(id);
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
      if (res.data) {
        const date = new Date(res.data?.document_date);
        setDocumentDate(date);
        const branch = branchForSearch?.find((item) => item.id === res.data?.branch_id);
        let item = null;
        let category = null;
        if (res.data?.type === "food") {
          const foodItem = foodForPOS?.find((item) => item.id === res.data.item_id);
          category = "Food Item"
          item = foodItem
        } else if (res.data?.type === "property") {
          const propertyItem = propertyItemList?.find((item) => item.id === res.data.item_id);
          category = "Property Item"
          item = propertyItem
        }
        setNewWastage({
          ...newWastage,
          branch,
          item,
          category,
          remarks: res.data?.remarks,
          document_identity: res.data?.document_identity,
          variation: res.data?.variation_name,
          type: res.data?.type === "raw" ? "raw material" : "finished goods",
          qty: res.data?.qty,
        })
        let newArr = [];
        if (res.data?.stock_wastage_details && res.data?.stock_wastage_details?.length > 0) {
          res.data.stock_wastage_details.map((item) => {
            newArr.push(item)
          })
          setNewRow([...newArr])
        }
      }
      handleOnlyPrint();

    } catch (error) {
      console.log("error==>", error)
    }
  }

  const handleFetchData = (page) => {
    setPaginatedWastageLists(page);
  };

  const getListData = useCallback(() => {
    if (searchedWastage.searched) {
      return searchedWastage.list || [];
    }
    return wastageItemList?.data || [];
  }, [searchedWastage, wastageItemList]);

  const onClearSearch = () => {
    setSearchedWastage({ ...searchedWastage, searched: false });
    if (searchRef.current) {
      searchRef.current.value = "";
    }
  };

  const [btnDisable, setBtnDisable] = useState("");

   const { canPoPost } = useMemo(() => {
    const permissions = authUserInfo?.permissions || [];
  
    return {
      canPoPost: checkPermission(permissions, "Wastage Post"),
    };
  }, [authUserInfo?.permissions]);

  const handlePostApi = async (id) => {
    setBtnDisable(id);
    setLoading(true);
    const url = BASE_URL + "/settings/mark-is-post-stock-wastage";
    const payload = {
      id,
      is_post: 1,
    };

    try {
      const res = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res.data) {
        setWastageItemList(res.data[0]);
        setWastageItemListForSearch(res.data[1]);
        setSearchedWastage({
          ...searchedWastage,
          list: res.data[1],
        });
        toast.success(`${_t(t("Wastage has been posted"))}`, common_toast);
      }
      setLoading(false);
      setBtnDisable("");
    } catch (error) {
      setLoading(false);
      setBtnDisable("");
      toast.error(`${_t(t("Please try again"))}`, common_toast);
    }
  };

  const renderActions = (item) => (
    <div className="d-flex justify-content-center">
      {item.is_post !== 1 && (
        <NavLink
          className="btn btn-primary ml-2 rounded-sm"
          to={`/dashboard/manage/stock/wastage-food-edit/${item.id}`}
          style={{ height: "1.7rem", width: "1.7rem" }}
        >
          <div className="d-flex align-items-center justify-content-center">
            <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
          </div>
        </NavLink>
      )}
      <NavLink
        className="btn btn-warning ml-2 rounded-sm"
        to={`/dashboard/manage/stock/wastage-food-view/${item.id}`}
        style={{ height: "1.7rem", width: "1.7rem" }}
      >
        <div className="d-flex align-items-center justify-content-center">
          <i className="fa fa-eye edit-icon" aria-hidden="true"></i>
        </div>
      </NavLink>
      <button
        className="btn btn-secondary ml-2 rounded-sm del-btn"
        onClick={() => handleGetPrintData(item.id)}
      >
        <i className="fa fa-print edit-icon"></i>
      </button>
      {canPoPost && item.is_post !== 1 && (
        <button
          className="btn btn-dark ml-2 rounded-sm del-btn"
          title="Post"
          style={{ padding: "1px 0px 0px 1px" }}
          disabled={loading || item.id === btnDisable}
          onClick={() => handlePostApi(item.id)}
        >
          <i className="fa fa-check-square-o" aria-hidden="true"></i>
        </button>
      )}
      {item?.sw_document &&
        <button
          title="Pi document"
          className="btn btn-light ml-2 rounded-sm del-btn"
          onClick={() => handleOpenPopup(item)}
        >
          <i className="fa fa-eye"></i>
        </button>
      }
    </div>
  );

  const COLUMNS = [
    {
      label: "S/L",
      render: (item, i) =>
        searchedWastage.searched
          ? i + 1
          : i + 1 + ((wastageItemList?.current_page || 1) - 1) * (wastageItemList?.per_page || 0),
    },
    { label: "Document No", key: "document_identity" },
    {
      label: "Document Date",
      render: (item) => (
        <Moment format="DD-MMMM-YYYY">{item.document_date}</Moment>
      ),
    },
    { label: "Branch", key: "branch_name" },
    { label: "Type", key: "type" },
    { label: "Item", key: "item_name" },
    { label: "Remarks", key: "remarks" },
    { label: "Action", render: (item) => renderActions(item) },
    { label: "Created By", key: "created_by_name" },
    { label: "Updated By", key: "updated_by_name" },

  ];

  return (
    <>
      <Helmet>
        <title>{_t(t("Wastage Items List"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div key="fragment3">
                  <KdsModal
                    show={itemData.modal}
                    handleClose={handleClosePopup}
                    itemData={itemData}
                  />

                  <div className="row mx-3 gx-2 align-items-center t-pt-15 t-pb-15">
                    <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                      <ul className="t-list fk-breadcrumb">
                        <li className="fk-breadcrumb__list">
                          <span className="t-link fk-breadcrumb__link text-capitalize">
                            {(t("Wastage Items List"))}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6 col-lg-7">
                      <div className="row gx-3 align-items-center">
                        {/* Search customer */}
                        <div className="col-md-9 t-mb-15 mb-md-0">
                          <div className="input-group">
                            <div className="form-file">
                              <input
                                ref={searchRef}
                                type="text"
                                className="form-control border-0 form-control--light-1 rounded-left"
                                placeholder={_t(t("Search")) + ".."}
                                onChange={handleSearch}
                              />
                            </div>
                            <button
                              className="btn btn-primary rounded-right"
                              type="button"
                            >
                              <i
                                className="fa fa-search"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </div>
                        </div>

                        {/* Add customer modal trigger button */}
                        <div className="col-md-3 text-md-right">
                          <NavLink
                            to="/dashboard/manage/stock/wastage-food-add"
                            className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                          >
                            {_t(t("add new"))}
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                  <DataTable
                    loading={loading || dataPaginating}
                    data={getListData()}
                    columns={COLUMNS}
                    emptyText="No data available"
                    pagination={{
                      isPageLoading: loading,
                      isPagination: true,
                      pageCount: wastageItemList?.last_page,
                      currentPage: wastageItemList?.current_page,
                      from: wastageItemList?.from,
                      to: wastageItemList?.to,
                      total: wastageItemList?.total,
                    }}
                    handleFetchData={handleFetchData}
                    searchPayload={{
                      isSearched: searchedWastage.searched,
                      onClearSearch,
                    }}
                  />
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
      <WastageReport
        name="Wastage Items"
        documentDate={documentDate}
        newWastage={newWastage}
        newRow={newRow}
        wastagePrint={componentRef}
      />
    </>
  )
}

export default WastageFood;